import { STREET } from "@/lib/terrain";

// v3 step 7: the street around a building square, drawn on the square's top face only
// (viewBox 0 0 100 100, like the other board layers). Outer 8 = half road with the dashed centre
// line exactly on the outer edge (two neighbours make one road with one centre line), then 7 of
// sidewalk, then the plot the building stands on. With a Green Street the sidewalk becomes a green
// verge with a blue rain swale along the plot and street trees.
const ROAD = 8;
const WALK = 15;
// Swale and inner sidewalk strip widths, from the mock-up (3 px each on a 180 px square).
const SWALE = 1.7;
const STRIP = 1.6;
const TREE_R = 3.2;
const TREE_C = (ROAD + WALK) / 2; // tree centre line, mid-verge
const ALONG_5 = [18, 34, 50, 66, 82];
const ALONG_3 = [34, 50, 66];

export default function StreetTile({ cellKey, green = false, opacity = 1, ghost = false }) {
  const inner = 100 - 2 * ROAD;
  const plot = 100 - 2 * WALK;
  const dash = { stroke: STREET.centreLine, strokeWidth: 2, strokeDasharray: "8 6" };
  return (
    <svg
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      className="absolute inset-0 w-full h-full pointer-events-none"
      data-testid={ghost ? `street-ghost-${cellKey}` : `street-${cellKey}`}
      data-green={green ? "true" : undefined}
      style={{ opacity, zIndex: ghost ? 3 : 1 }}
      aria-hidden="true"
    >
      {!ghost && (
        <>
          <rect x={0} y={0} width={100} height={100} fill={STREET.road} />
          <line x1={0} y1={0} x2={100} y2={0} {...dash} />
          <line x1={0} y1={100} x2={100} y2={100} {...dash} />
          <line x1={0} y1={0} x2={0} y2={100} {...dash} />
          <line x1={100} y1={0} x2={100} y2={100} {...dash} />
        </>
      )}
      <rect x={ROAD} y={ROAD} width={inner} height={inner} fill={green ? STREET.verge : STREET.sidewalk} />
      {green && <rect x={WALK - SWALE - STRIP} y={WALK - SWALE - STRIP} width={plot + 2 * (SWALE + STRIP)} height={plot + 2 * (SWALE + STRIP)} fill={STREET.swale} />}
      {green && <rect x={WALK - STRIP} y={WALK - STRIP} width={plot + 2 * STRIP} height={plot + 2 * STRIP} fill={STREET.sidewalk} />}
      <rect x={WALK} y={WALK} width={plot} height={plot} fill={STREET.plot} />
      {green && (
        <g data-testid={ghost ? undefined : `street-trees-${cellKey}`} fill={STREET.tree}>
          {ALONG_5.map((x) => (
            <g key={`h${x}`}>
              <circle cx={x} cy={TREE_C} r={TREE_R} />
              <circle cx={x} cy={100 - TREE_C} r={TREE_R} />
            </g>
          ))}
          {ALONG_3.map((y) => (
            <g key={`v${y}`}>
              <circle cx={TREE_C} cy={y} r={TREE_R} />
              <circle cx={100 - TREE_C} cy={y} r={TREE_R} />
            </g>
          ))}
        </g>
      )}
    </svg>
  );
}
